module.exports = __webpack_public_path__ + "img/ctrl-st-stub-up-1.34323a4e.svg";